import { prependBackendAPIHost } from "repoV2/utils/common/api/api";

export const PART_PAYMENT_APIS = {
    instalments_details: ({ listingUuid }: { listingUuid: string }) =>
        prependBackendAPIHost(`payments/installment/details/${listingUuid}`),
};
